const ESCAPED_CHARACTER_PATTERN = /\\(["'\\nrt])/g;

const ESCAPED_CHARACTER_VALUES = {
  '"': '"',
  "'": "'",
  '\\': '\\',
  n: '\n',
  r: '\r',
  t: '\t',
};

const normalizeTranslationText = (value) => {
  if (typeof value !== 'string') return value;

  return value.replace(
    ESCAPED_CHARACTER_PATTERN,
    (_, escapedCharacter) => ESCAPED_CHARACTER_VALUES[escapedCharacter]
  );
};

export default normalizeTranslationText;
